import { createClient } from '@supabase/supabase-js';

// Your Supabase project URL (can be overridden via REACT_APP_SUPABASE_URL env var)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://vtkfqqjhtgkajuepvyfb.supabase.co';
// Get the anon key from environment variables
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseAnonKey) {
  throw new Error(
    'Missing Supabase anon key. Please set REACT_APP_SUPABASE_ANON_KEY in your .env file.'
  );
}

// Validate that the key looks like a JWT (anon key) not a publishable key
if (supabaseAnonKey.startsWith('sb_publishable_')) {
  console.warn(
    '⚠️ Warning: You are using a publishable key. Supabase Auth requires the "anon" key (JWT token starting with "eyJ"). ' +
    'Please get the correct key from: Supabase Dashboard → Settings → API → anon public key'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false, // For web apps, we handle routing manually
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});

